import { Typography } from "@mui/material";

export const ErrorComponent = ({error}) => {
    return <Typography variant="h6">An Error Occurred: {error.errorCode}</Typography>;
    //return <Typography variant="h6">Please login with microsoft.</Typography>;
}